import { render, staticRenderFns } from "./BaseDropdownSubmenu.vue?vue&type=template&id=2c6cb63e&scoped=true&lang=html"
import script from "./BaseDropdownSubmenu.vue?vue&type=script&lang=js"
export * from "./BaseDropdownSubmenu.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdownSubmenu.vue?vue&type=style&index=0&id=2c6cb63e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cb63e",
  null
  
)

export default component.exports